import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Paper, Grid, TextField, IconButton } from '@material-ui/core';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import PanToolOutlinedIcon from '@material-ui/icons/PanToolOutlined';
import CallMadeOutlinedIcon from '@material-ui/icons/CallMadeOutlined';
import PhotoCameraOutlinedIcon from '@material-ui/icons/PhotoCameraOutlined';
import { useDispatch } from 'react-redux';

import { updateSheet, SheetKinds } from '../redux/sheetDbSlice';

import { WorkAreaStateType, HandlingStates, HandlingStateSetters } from './BookEditor';
import { ToggleBookTreeButton } from './BookTree';

const WorkAreaHeaderPaper = styled(Paper)`
  position: sticky;
  top: 0;
  left: 0;
  z-index: 10;
  padding: 10px 10px 0 10px;
  margin-bottom: 10px;
`
const LargeInfoOutlinedIcon = styled(InfoOutlinedIcon)`
  font-size: 32px;
`
const LargePhotoCameraOutlinedIcon = styled(PhotoCameraOutlinedIcon)`
  font-size: 32px;
`
const ModeGrid = styled(Grid)`
  text-align: right;
`

type WorkAreaHedderProps = {
  infoClicked: (workArea: WorkAreaStateType) => void;
  handlingStates: HandlingStates;
  handlingStateSetters: HandlingStateSetters;
  currentSheet: { id: string, name: string, sheetKind: SheetKinds } | undefined;
  openScreenshotDialog: () => void;
}
const WorkAreaHeader: React.FC<WorkAreaHedderProps> = ({infoClicked, handlingStates, handlingStateSetters, currentSheet, openScreenshotDialog}) => {
  const dispatch = useDispatch();
  const mode = handlingStates.mode;
  const setMode = handlingStateSetters.setMode;
  const [name, setName] = useState(' ');

  const changeSheetName = (ev: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const newSheetName = ev.target.value;
    if (currentSheet) {
      setName(newSheetName);
      dispatch(updateSheet({id: currentSheet.id, name: newSheetName}));
    }
  }
  const fillBlank = (ev: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (!ev.target.value && currentSheet) dispatch(updateSheet({id: currentSheet.id, name: '新しいシート'}));
  }
  const handleOperationMode = () => {
    if (mode === 'move') setMode('connect');
    else setMode('move');
  }

  useEffect(() => {
    if (currentSheet) setName(currentSheet.name);
  }, [currentSheet])

  return (
    <WorkAreaHeaderPaper id="word-area-header" elevation={0}>
      <Grid container spacing={1}>
        <Grid item xs={7}>
          <Grid container direction="row" spacing={2}>
            <Grid item><ToggleBookTreeButton /></Grid>
            <Grid item style={{ width: '80%' }}>
            <TextField variant="outlined"
              label="シート名"
              value={name}
              onChange={changeSheetName}
              onBlur={fillBlank}
              fullWidth
            />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={1}>
          <IconButton data-html2canvas-ignore="true" onClick={() => infoClicked('sheetInfo')}><LargeInfoOutlinedIcon /></IconButton>
        </Grid>
        <Grid item xs={1}>
          <IconButton data-html2canvas-ignore="true" onClick={openScreenshotDialog}><LargePhotoCameraOutlinedIcon /></IconButton>
        </Grid>
        { (currentSheet?.sheetKind === 'map' || currentSheet?.sheetKind === 'grid') &&
          <ModeGrid item xs={3}>
            <ToggleButtonGroup
              data-html2canvas-ignore="true"
              value={mode}
              exclusive
              onChange={handleOperationMode}
              size="large"
            >
              <ToggleButton value="move">
                <PanToolOutlinedIcon />
              </ToggleButton>
              <ToggleButton value="connect">
                <CallMadeOutlinedIcon />
              </ToggleButton>
            </ToggleButtonGroup>
          </ModeGrid>
        }
      </Grid>
    </WorkAreaHeaderPaper>
  );
}

export default WorkAreaHeader;
